import React from 'react';
import styled from 'styled-components';
import { AltAccordion } from 'components';
import { toRem } from 'design';
import { sortAlphaNumerically } from 'utils';
import { centsToDollarsDisplay } from 'utils/currency';
import EmployeeListItem, { IEmployeeListItemProps } from '../EmployeeListItem/EmployeeListItem';

export interface IAccordionListItemProps {
  className?: string;
  defaultOpenState?: boolean;
  listItems: IEmployeeListItemProps[];
  title: string;
  totalAmount: number;
}

const StyledTipAmountEntryList = styled.ul`
  & > * {
    margin-bottom: ${toRem(8)};
  }
`;

const AccordionListItem: React.FC<IAccordionListItemProps> = ({ className = '', defaultOpenState, listItems, title, totalAmount }) => {
  // sort by title
  const tipAmountListItems = (listItems || []).sort(sortAlphaNumerically('title')).map((listItem, i) => <EmployeeListItem key={`${listItem.title}-${i}`} {...listItem} />);

  if (!listItems?.length) return null;

  return (
    <AltAccordion className={className} defaultOpenState={defaultOpenState} leftContent={title} rightContent={`Net Total: ${centsToDollarsDisplay(totalAmount)}`} dataCy="accordion-tip-data-list-item">
      <StyledTipAmountEntryList>{tipAmountListItems}</StyledTipAmountEntryList>
    </AltAccordion>
  );
};

export default AccordionListItem;
